import { colors } from '@ardoq/design-tokens';
import { TextOverflow } from '@ardoq/popovers';
import { HTMLAttributes } from 'react';
import styled from 'styled-components';

const TextContainer = styled.div`
  overflow: hidden;
`;

const Label = styled.div`
  color: ${colors.grey700};
  font-size: 11px;
  font-style: italic;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  word-break: break-all;
`;

type TruncatingReferenceLabelProperties = {
  label: string;
  fieldLabel?: string;
  fieldValue?: string;
};

export const TruncatingReferenceLabel = ({
  label,
  fieldLabel,
  fieldValue,
  ...props
}: TruncatingReferenceLabelProperties & HTMLAttributes<HTMLDivElement>) => {
  const isActiveFilteringApplied = fieldLabel && fieldValue;
  return (
    <TextContainer>
      <Label {...props}>
        <TextOverflow lineClamp={fieldValue ? 2 : 3} textContent={label}>
          {isActiveFilteringApplied ? `${fieldLabel}:` : label}
        </TextOverflow>
        {isActiveFilteringApplied && (
          <TextOverflow lineClamp={1} textContent={label}>
            {fieldValue}
          </TextOverflow>
        )}
      </Label>
    </TextContainer>
  );
};
